(ns frontend.view.modals.folder-management-modal.event
  (:require
   [clojure.edn :as edn]
   [common.util :as cu]
   [frontend.controller.websocket.event :as ws]
   [frontend.logging :as logging]
   [frontend.view.modals.folder-management-modal.sub :as sub]
   [re-frame.core :as rf]))


(rf/reg-event-fx
 ::init
 (fn [{db :db} [_ entity]]
   (let [fs (:common/folder-structure entity)
         fs (cond (map? fs)
                  fs
                  (string? fs)
                  (edn/read-string fs))
         sorted-folders (->> fs
                             (keys)
                             (sort-by cu/str-trim-lcase)
                             (vec))
         folder-list (->> sorted-folders
                          (map-indexed (fn [idx folder-name]
                                         {:folder-name   folder-name
                                          :original-name folder-name
                                          :status        :ok
                                          :index         idx}))
                          (vec))]
     {:db (-> db
              (assoc ::sub/target-entity (:db/id entity))
              (assoc ::sub/original-list sorted-folders)
              (assoc ::sub/temp-list folder-list))})))

(rf/reg-event-fx
 ::add-folder
 (fn [{db :db} _]
   {:db (-> db
            (update-in [::sub/temp-list]
                       (fn [e]
                         (vec (concat e
                                      [{:folder-name ""
                                        :status      :new
                                        :index       (count e)}])))))}))

(rf/reg-event-fx
 ::edit-folder-name
 (fn [{db :db} [_ {:keys [index] :as item} new-name]]
   {:db (-> db
            (update-in [::sub/temp-list]
                       (fn [arr]
                         (cu/update-at arr
                                       index
                                       (fn [item]
                                         (assoc item
                                           :folder-name new-name
                                           :status :renamed))))))}))
(rf/reg-event-fx
 ::remove-folder-name
 (fn [{db :db} [_ {:keys [index] :as item}]]
   {:db (-> db
            (update-in [::sub/temp-list]
                       (fn [arr]
                         (cu/update-at arr
                                       index
                                       (fn [item]
                                         (assoc item :status :removed))))))}))

(rf/reg-event-fx
 ::clear
 (fn [{db :db} _]
   {:db (-> db
            (dissoc ::sub/temp-list
                    ::sub/original-list
                    ::sub/processing?))}))

(rf/reg-event-fx
 ::save-ok
 (fn [{db :db} [_ close-modal! resp]]
   (when (fn? close-modal!)
     (close-modal!))
   {:db (dissoc db ::sub/processing?)}))

(rf/reg-event-fx
 ::save-failed
 (fn [{db :db} [_ resp]]
   (let [error (some->> resp
                        :body
                        :error-message)]
     (logging/warn (str ::save-failed " " resp))
     {:db (-> db
              (dissoc ::sub/processing?)
              (assoc ::sub/error error))})))

(rf/reg-event-fx
 ::save!
 (fn [{db :db} [_ entity close-modal!]]
   (let [temp-list (get db ::sub/temp-list)
         new-structure (->> temp-list
                            (cu/remove-by :status :removed)
                            (map :folder-name)
                            (map (fn [n]
                                   [n {}]))
                            (into {}))
         msg {:new-folder-structure (pr-str new-structure)
              :entity-id            (get db ::sub/target-entity)
              :removed              (->> temp-list
                                         (cu/filter-by :status :removed)
                                         (keep :original-name)
                                         (set))
              :renamed              (->> temp-list
                                         (cu/filter-by :status :renamed)
                                         (keep (fn [{:keys [folder-name original-name]}]
                                                 (when original-name
                                                   [original-name folder-name])))
                                         (into {}))}]
     {:db       (assoc-in db [::sub/processing?] true)
      ::ws/send {:id         :entity/set-folders
                 :body       msg
                 :on-success [::save-ok close-modal!]
                 :on-error   [::save-failed]}})))
